import React, { useEffect } from 'react';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import { Title1, Headline } from '../../../../components/Typography';
import { PrimaryButton } from '../../../../components/Buttons';
import OrderFutureSchedule from '../../OrderSettingModal/components/OrderFutureSchedule';
import appConfig from '../../../../../app-config';
import SkeletonLoading from '../../OrderSettingModal/components/SkeletonLoading';
import { isConfirmButtonDisabled } from '../../../OrderSetting/OrderSettingModal/utils/helper';
import ConfirmButton from '../../../OrderSetting/OrderSettingModal/components/ConfirmButton';
import { isScheduleRadioDisabledCalculated } from '../../OrderSettingModal/utils/helper';
import UnavailableMessage from '../../../OrderSetting/OrderSettingModal/components/UnavailableMessage';
import UnavailableProducts from '../../OrderSettingModal/components/UnavailableProducts';

const Wrapper = styled.div`
  font-family: ${(props) => props.theme.primaryFontFontFamily};
  padding: 32px;
  max-width: 500px;

  // height: 1000px;
  @media (min-width: 786px) {
    width: 500px;
  }
`;

const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
`;

const FormWrapper = styled.div`
  position: relative;
  margin-top: 14px;
  display: grid;
  gap: 21px;
`;

const SelectLabel = styled.p`
  margin-bottom: 8px;
`;

const ButtonWrapper = styled.div`
  display: grid;
  // grid-template-rows: 1fr;
  grid-gap: 14px;
  margin-top: 40px;
`;

const Delete = styled(Headline)`
  color: ${(props) =>
    props.disabled
      ? props.theme.primaryButtonDisabledColor
      : props.theme.black};
  align-self: center;
  cursor: pointer;
`;

const SaveButton = styled(PrimaryButton)`
  width: 70%;
  margin: auto;
  height: 56px;

  @media screen and (max-width: 767px) {
    width: 100%;
    margin: auto;
    min-width: auto;
  }
`;

const DeleteButton = styled(PrimaryButton)`
  width: 70%;
  margin: auto;
  height: 56px;
  font-size: 19px;
  font-weight: 600;

  background-color: ${(props) =>
    props.theme.deleteLocationButtonBackgroundColor};
  color: ${(props) => props.theme.deleteLocationButtonTextColor};

  &:hover {
    background-color: ${(props) =>
      props.theme.deleteLocationButtonBackgroundColor};
    color: ${(props) => props.theme.deleteLocationButtonTextColor};
    transition: all 0.25s ease;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    margin: auto;
    min-width: auto;
  }
`;

const CloseButton = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: white;
  background-color: ${(props) => props.theme.darkGray};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.closeButtonHoverColor};
    transition: all 0.25s ease;
  }
`;

const styles = (theme) => ({
  input: {
    fontFamily: theme.typography.fontFamily.main,
  },
});

const DeliveryTimeForm = ({
  setDeliveryTimeFormIsVisible,
  interDeliveryDetails,
  interOrderType,
  interSelectedDateTime,
  updateInterSelectedDateTime,
  confirmDeliveryDetails,
  availableTimes,
  selectedDateTime,
  isTimeNoLongerValid,
  resetIsTimeNoLongerValid,
  getTimeIntervalsDate,
  specialHours,
  orderPacingData,
  isOnline,
  emptySearchBox,
  deepLinkParameters,
  isConfirmMarketPlaceDeliveryDetailsRequest,
  unavailableProducts,
  cartErrorMessage,
  checkUnavailableProductForMarketplace,
  resetUnavailableProducts,
  cartReducer,
  resetCartErrorMessages,
  updateOrderSettingModalIsVisible,
  selectedLocation,
  onSeeMenu,
  selectMarketplaceDeliveryLocation,
  updateCartWithUnavailbleProducts,
  isAuthenticated,
  emptyCart,
  updateUnavailableProducts,
  updateSelectedLocation,
  setShowConfirmButton,
  showConfirmButton,
  validateCartForLocation,
}) => {
  const maxFutureOrderDate =
    interDeliveryDetails &&
    interDeliveryDetails.settings &&
    interDeliveryDetails.settings.max_future_order_date;

  const orderEndTime =
    availableTimes &&
    availableTimes.length &&
    (availableTimes.length > 1
      ? availableTimes[1].order_end_time
      : availableTimes[0].order_end_time);

  const isAsapRadioDisabled =
    !(
      interDeliveryDetails &&
      interDeliveryDetails?.deliveryBusiness?.accepting_orders
    ) ||
    !isOnline ||
    (orderPacingData && !orderPacingData.is_asap_slot_available);

  let isScheduleRadioDisabled = true;

  if (
    !isConfirmMarketPlaceDeliveryDetailsRequest &&
    interDeliveryDetails &&
    interDeliveryDetails.isDeliveryValid
  ) {
    isScheduleRadioDisabled = isScheduleRadioDisabledCalculated(
      availableTimes,
      maxFutureOrderDate,
      orderEndTime,
      specialHours,
      isOnline
    );
  }

  useEffect(() => {
    if (
      (interSelectedDateTime.radioValue.value === 'asap' ||
        interSelectedDateTime.dateTime.time.value.length) &&
      interOrderType === 'delivery'
    ) {
      checkUnavailableProductForMarketplace(interDeliveryDetails);
    }
  }, [interSelectedDateTime.radioValue.value]);
  return (
    <Wrapper>
      <TitleWrapper>
        <Title1 style={{ fontWeight: '600', marginBottom: '20px' }}>
          Delivery Time
        </Title1>

        <CloseButton
          onClick={() => {
            resetUnavailableProducts();
            setDeliveryTimeFormIsVisible(false);
            resetCartErrorMessages();
            updateUnavailableProducts(null);
          }}
        >
          <i
            className='fas fa-times'
            style={{ fontSize: '24px', cursor: 'pointer' }}
          ></i>
        </CloseButton>
      </TitleWrapper>
      <div style={{ marginBottom: '32px' }}>
        {isConfirmMarketPlaceDeliveryDetailsRequest ? (
          <SkeletonLoading />
        ) : !isConfirmMarketPlaceDeliveryDetailsRequest &&
          interDeliveryDetails &&
          !interDeliveryDetails.isDeliveryValid ? (
          <UnavailableMessage
            marginTop='10px'
            title={
              interDeliveryDetails.errorMessage ||
              '*We are unable to deliver to this address'
            }
          />
        ) : !isConfirmMarketPlaceDeliveryDetailsRequest ? (
          <OrderFutureSchedule
            interDeliveryDetails={interDeliveryDetails}
            interOrderType={interOrderType}
            interSelectedDateTime={interSelectedDateTime}
            selectedLocation={selectedLocation}
            updateInterSelectedDateTime={updateInterSelectedDateTime}
            confirmDeliveryDetails={confirmDeliveryDetails}
            availableTimes={availableTimes}
            selectedDateTime={selectedDateTime}
            maxFutureOrderDate={
              interDeliveryDetails &&
              interDeliveryDetails.deliveryBusiness &&
              interDeliveryDetails.deliveryBusiness.settings
                .max_future_order_date
            }
            updateSelectedLocation={updateSelectedLocation}
            deliveryBusiness={
              interDeliveryDetails && interDeliveryDetails.deliveryBusiness
            }
            isTimeNoLongerValid={isTimeNoLongerValid}
            resetIsTimeNoLongerValid={resetIsTimeNoLongerValid}
            isLocationOrDelivBusinesssAcceptingOrders={
              interDeliveryDetails &&
              interDeliveryDetails.deliveryBusiness.accepting_orders
            }
            getTimeIntervalsDate={getTimeIntervalsDate}
            specialHours={specialHours}
            orderPacingData={orderPacingData}
            orderMessage={appConfig.orderMessageDelivery}
            isOnline={
              interDeliveryDetails &&
              interDeliveryDetails.deliveryBusiness &&
              interDeliveryDetails.deliveryBusiness.settings.online
            }
            emptySearchBox={() => emptySearchBox()}
            deepLinkParameters={deepLinkParameters}
            isMarketplaceDelivery={true}
            setDeliveryTimeFormIsVisible={setDeliveryTimeFormIsVisible}
            is_asap_order_enabled={
              interDeliveryDetails &&
              interDeliveryDetails.deliveryBusiness.settings
                .is_asap_order_enabled
            }
            is_future_order_enabled={
              interDeliveryDetails &&
              interDeliveryDetails.deliveryBusiness.settings
                .is_future_order_enabled
            }
            cartReducer={cartReducer}
            onSeeMenu={onSeeMenu}
            selectMarketplaceDeliveryLocation={
              selectMarketplaceDeliveryLocation
            }
            emptyCart={emptyCart}
            setShowConfirmButton={setShowConfirmButton}
            showConfirmButton={showConfirmButton}
          />
        ) : (
          <UnavailableMessage
            marginTop='10px'
            title={
              interDeliveryDetails.errorMessage ||
              'We are unable to deliver to this address'
            }
          />
        )}
        {unavailableProducts && unavailableProducts.length ? (
          <UnavailableProducts
            cartErrorMessage={cartErrorMessage}
            marginBottom='25px'
          />
        ) : null}
      </div>
      {!isConfirmMarketPlaceDeliveryDetailsRequest && showConfirmButton && (
        <ConfirmButton
          text={
            isAsapRadioDisabled &&
            isScheduleRadioDisabled &&
            interDeliveryDetails &&
            !interDeliveryDetails.isDeliveryValid
              ? 'See Menu'
              : 'Confirm'
          }
          onClick={() => {
            selectMarketplaceDeliveryLocation();
            confirmDeliveryDetails(true);

            if (!isAuthenticated) {
            } else if (unavailableProducts && unavailableProducts.length > 0) {
              updateCartWithUnavailbleProducts(unavailableProducts);
            }
            validateCartForLocation(interDeliveryDetails);
            setDeliveryTimeFormIsVisible(false);
            updateOrderSettingModalIsVisible(false);
            resetCartErrorMessages();
          }}
          disabled={
            !interDeliveryDetails ||
            (interDeliveryDetails && !interDeliveryDetails.deliveryBusiness) ||
            isConfirmButtonDisabled(
              interSelectedDateTime,
              interDeliveryDetails,
              interOrderType,
              appConfig.isFutureOrderDelivery
            ) ||
            !interDeliveryDetails.isDeliveryValid ||
            !interDeliveryDetails?.deliveryBusiness?.settings?.online ||
            (!interDeliveryDetails?.deliveryBusiness?.settings
              ?.is_asap_order_enabled &&
              !interDeliveryDetails?.deliveryBusiness?.settings
                ?.is_future_order_enabled)
          }
        />
      )}
    </Wrapper>
  );
};

export default withStyles(styles)(DeliveryTimeForm);
